<template>
  <div id="container" style="    width: 100%;">
    <a-spin :spinning="reloading">
      <div style="display: flex;margin-bottom: 20px;    align-items: center;">
        <a-range-picker format="YYYY-MM-DD HH:mm:ss" show-time v-model:value="rangeTime" @change="changeTime" />
        <div class="datelist">
          <a @click="toSearchUser(1)">近一日</a>
          <a @click="toSearchUser(7)">近一周</a>
          <a @click="toSearchUser(30)">近一月</a>
        </div>
        <a-button @click="deleteShow()" type="primary" :disabled="!(selectedRowKeys.length > 0)">批量删除</a-button>
      </div>
      <div  class="scrollView">
        <a-table rowKey='companyId'
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, getCheckboxProps: getCheckboxProps }"
          :columns="columns" :data-source="tableList" bordered class="tablestyle" :pagination="pagination"
          @change="handleTableChange">
          <template #bodyCell="{ column, text, record, index }">
            <template v-if="column.dataIndex === 'action'">
              <a v-if="index == 0" disabled style="color:'gray'">删除该用户</a>
              <a v-else @click="deleteShow(record)">删除该用户</a>
            </template>
          </template>
        </a-table>
        <div>
        </div>
      </div>
    </a-spin>
  </div>
  <!--<a-modal  v-model:visible="visible" :bodyStyle="{height:'90%',width:'500px'}">
       <iframe src="https://www.enplus.org.cn/vuePostertest/#/?id=129512&companyId=32&loading=true"></iframe>
    </a-modal>-->
  <a-modal centered width="20%" title="" v-model:visible="visible" :afterClose="afterClose" :closable="false"
    :footer="null">
    <div style="text-align: center;">
      <p>确定删除所选同事？</p>
      <div>
        <a-button @click="toDelete" :loading="confrimLoading" style="margin-right: 30px;" type="primary">确认</a-button>
        <a-button @click="afterClose">取消</a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { paginationCurrent } from '../../untils/index'
import { getPayingGroupClient, removePayingGroupByCompanyIds } from './js/index'
import { reactive, watch, ref, onMounted, toRefs, computed } from 'vue'
import store from '@/store'
import dayjs from 'dayjs'
import { message } from 'ant-design-vue/lib/components'
export default {
  name: 'personPage',
  setup() {
    watch(() => store.getters.company, (val) => {
      if (val && val != '') {
        var height = document.getElementById('container').offsetHeight
        scrollView.value = { height: (height - 60) + 'px', overflow: 'auto' }
        pagination.companyId = store.getters.company.companyId
        toShowTable()
      }
    })
    onMounted(() => {
      rangeTime.value = [dayjs(dayjs().subtract(1, 'day').format('YYYY-MM-DD') + " 00:00:00"), dayjs(dayjs().format('YYYY-MM-DD') + " 00:00:00")]
      var height = document.getElementById('container').offsetHeight
      scrollView.value = { height: (height - 60) + 'px', overflow: 'auto' }
      if (store.getters.company) {
        pagination.companyId = store.getters.company.companyId
        toShowTable()
      }
    })
    const toShowTable = () => {
      state.selectedRowKeys = []
      reloading.value = true
      var startTime = ''
      var endTime = ''
      if (rangeTime.value[0] != '') {
        startTime = dayjs(rangeTime.value[0]).format(dateFormat)
        endTime = dayjs(rangeTime.value[1]).format(dateFormat)
      }
      var list = { companyId: pagination.companyId, startTime: startTime, endTime: endTime }
      getPayingGroupClient(list).then((res) => {
        pagination.total = res.data.total
        tableList.value = res.data
        reloading.value = false
      })
    }
    const pagination = reactive({
      current: 1,
      pageSize: 10,
      companyId: '',
      total: 0,
      showTotal: function (total) {
        return "共：" + total + " 条";
      },
    })
    const tableList = ref([])
    const scrollView = ref('')
    const dateFormat = 'YYYY-MM-DD HH:mm:ss';
    const handleScroll = (e) => {
      let scrollTop = e.target.scrollTop; //滑入屏幕滚动条滚动时，距离顶部的距离
      let windowHeitht = e.target.clientHeight; //能看到的页面的高度
      let scrollHeight = e.target.scrollHeight; //监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
      let total = scrollTop + windowHeitht
      if (scrollHeight - total < 20) {
        if (articleList.value.length != pagination.total) {
          if (reloading.value == false) {
            pagination.current = pagination.current + 1
            toShowTable()
          }
        }
      }
    }
    const reloading = ref(false)
    const visible = ref(false)
    const rangeTime = ref(['', ''])
    const changeTime = () => {
      if (rangeTime.value == null) {
        message.warning('时间不能为空')
      }
      else {
        tableList.value = []
        pagination.current = 1
        toShowTable()
      }
    }
    const scrollY = ref(0)
    const toSearchUser = (val) => {
      pagination.current = 1
      rangeTime.value = [
        dayjs(dayjs().subtract(val, 'day').format("YYYY-MM-DD") + ' 00:00:00'),
        dayjs(dayjs().format("YYYY-MM-DD") + ' 00:00:00')
      ]
      tableList.value = []
      toShowTable()
    }
    const deleteShow = (val) => {
      if (val) deleteList.value = [val.companyId]
      else deleteList.value = state.selectedRowKeys
      visible.value = true
    }
    const state = reactive({
      selectedRowKeys: []
    })
    const onSelectChange = (selectedRowKeys) => {
      state.selectedRowKeys = selectedRowKeys
    };
    const deleteList = ref([])
    const afterClose = () => {
      deleteList.value.length = []
      visible.value = false
    }
    const toDelete = () => {
      if (confrimLoading.value == false) {
        confrimLoading.value = true
        removePayingGroupByCompanyIds({ companyIds: deleteList.value.toString() }).then((res) => {
          if (res.data == true) {
            message.success('删除成功')
            afterClose()

            pagination.current = paginationCurrent(pagination, deleteList.value.length)

            toShowTable()
          }
          confrimLoading.value = false
        }).catch(() => {
          confrimLoading.value = false
        })
      }

    }
    const getCheckboxProps = (record) => {
      return {
        disabled: record.companyId.toString() == store.getters.company.companyId, // Column configuration not to be checked
      }
    }
    const confrimLoading = ref(false)
    return {
      confrimLoading,
      getCheckboxProps,
      toDelete,
      visible,
      afterClose,
      deleteList,
      onSelectChange,
      ...toRefs(state),
      deleteShow,
      columns: [
        {
          title: " 序号 ",
          // render: (text, record, index) => `${index + 1}`,  //每一页都从1开始
          customRender: (column) =>
            `${(pagination.current - 1) * pagination.pageSize + column.index + 1
            }`,
          width: "7%",
          align: 'center'
          //当前页数减1乘以每一页页数再加当前页序号+1
        },
        {
          dataIndex: "userName",
          key: "userName",
          title: "用户名称",
          align: 'center'
        },
        {
          dataIndex: "mobile",
          key: "mobile",
          title: "手机号",
          align: 'center'
        },
        {
          dataIndex: "read",
          key: "read",
          title: "阅读次数",
          align: 'center',
          sorter: (a, b) => {
            return a.read - b.read
          }
        },
        {
          dataIndex: "share",
          key: "share",
          title: "分享次数",
          align: 'center',
          sorter: (a, b) => {
            return a.share - b.share
          }
        },
        {
          dataIndex: "favor",
          key: "favor",
          title: "收藏次数",
          align: 'center',
          sorter: (a, b) => {
            return a.favor - b.favor
          }
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'action',
        },
      ],
      toSearchUser,
      scrollY,
      changeTime,
      rangeTime,
      visible,
      reloading,
      scrollView,
      tableList,
      toShowTable,
      pagination,
    }
  },
  beforeRouteLeave(to, from, next) {
    //保存滚动条元素div的scrollTop值
    this.scrollY = document.querySelector('.scrollView').scrollTop
    next();
  },
  methods: {
    handleTableChange(page) {
      this.pagination.current =
        page.pageSize != this.pagination.pageSize ? 1 : page.current;
      this.pagination.pageSize = page.pageSize;
      scrollTo(0, 0)
    },
  }
}
</script>
<style>
.tablestyle .ant-table-thead>tr>th,
.ant-table-tbody>tr>td {
  padding: 8px 8px !important;
}
</style>
 <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.tablestyle {
  margin-top: 20px;
}

.scrollView {
  margin: 10px 0px;
}

.datelist {
  margin-left: 10px;
  display: inline-block;
}

.datelist a {
  margin-right: 10px;
}
</style>